import { useFlag } from '@openfeature/react-sdk';

import { availableFeatureFlags } from './feature-flags-provider';

export const useCanUseNavigationBetaItems = () => {
  return useFlag(availableFeatureFlags.CAN_USE_NAVIGATION_BETA_ITEMS, false);
};
